var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialGoogleRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.938 20.199c0-.735-.061-1.271-.193-1.827h-8.562v3.316h5.026c-.102.825-.649 2.066-1.865 2.9l-.017.111 2.707 2.055.188.019c1.723-1.56 2.716-3.853 2.716-6.574z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.182 28.938c2.462 0 4.53-.795 6.04-2.165l-2.879-2.185c-.77.526-1.803.894-3.161.894a5.48 5.48 0 01-5.188-3.714l-.107.008-2.816 2.136-.036.1c1.5 2.92 4.58 4.925 8.147 4.925z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.994 21.767A5.4 5.4 0 0115.69 20c0-.616.112-1.212.294-1.768l-.005-.118-2.85-2.17-.094.044A8.8 8.8 0 0012.062 20c0 1.44.355 2.8.973 4.012l2.96-2.245z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.182 14.518c1.712 0 2.867.725 3.526 1.331l2.574-2.463c-1.58-1.44-3.638-2.323-6.1-2.323-3.567 0-6.648 2.005-8.147 4.925l2.948 2.244a5.503 5.503 0 015.199-3.714z",
    fill: "#EB4335"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}
export default SvgSocialGoogleRound;